const OPACITY_INITIAL = 100

// A shader's old `uniforms` bag becomes its keyed `source_settings` entry; the retired 0–1 `alpha` gate lands on opacity unless one is explicit.
export function uniformsToSourceSettings(settings) {
	const objects = settings?.objects
	if (!objects || typeof objects !== 'object') return settings

	let changed = false
	const next = {}
	for (const [id, obj] of Object.entries(objects)) {
		next[id] = obj
		if (!obj || typeof obj !== 'object' || !('uniforms' in obj)) continue

		const { uniforms, ...rest } = obj
		const { alpha, ...values } = uniforms && typeof uniforms === 'object' ? uniforms : {}

		if (typeof alpha === 'number' && Number.isFinite(alpha) && !('opacity' in rest)) {
			const opacity = Math.round(Math.min(100, Math.max(0, alpha <= 1 ? alpha * 100 : alpha)))
			if (opacity !== OPACITY_INITIAL) rest.opacity = opacity
		}
		// Only a shader owns the bag; against any other source it was stranded.
		const source = rest.source
		if (
			typeof source === 'string' &&
			source.startsWith('shader:') &&
			Object.keys(values).length &&
			!rest.source_settings
		)
			rest.source_settings = { [source]: values }

		next[id] = rest
		changed = true
	}

	return changed ? { ...settings, objects: next } : settings
}

export default uniformsToSourceSettings
